import { render, staticRenderFns } from "./opposing_wrestler_create.vue?vue&type=template&id=17a42b00&"
import script from "./opposing_wrestler_create.vue?vue&type=script&lang=js&"
export * from "./opposing_wrestler_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports